<!--
component: ImageCanvas
author: Ken Nakamura
description: 画像表示コンポーネント（HTML5 Canvas版）
-->
<template>
  <section class="image-viewer">
    <!--
    <div style="width:100%; height:100%; overflow:auto; position:relative;">
    -->
    <div class="canvas-parent">
      <canvas :id="canvasId"
        class="grab-bing pb-1" style="position:absolute; padding:0; margin:0;"
        @click="onClick($event)"
        @mousedown="onMouseDown($event)"
        @mouseup="onMouseUp()"
        @mouseleave="onMouseLeave($event)"
        @mousewheel="onMouseWheel($event)"
        @mousemove="onMouseMove($event)"
      ></canvas>
      <canvas id="overlay-canvas"
        style="position:absolute; cursor:move; padding:0; margin:0;"
        @click="overlayClick($event)"
        @mousedown="overlayMouseDown($event)"
        @mouseup="overlayMouseUp()"
        @mousemove="overlayMouseMove($event)"
        @mouseleave="overlayLeave($event)"
        @mousewheel="overlayWheel($event)"
        v-show="frameVisible"
      ></canvas>
      <canvas id="split-canvas"
        style="position:absolute; cursor:move; padding:0; margin:0;"
        @click="splitClick($event)"
        @dblclick="splitDblClick($event)"
        @mousedown="splitMouseDown($event)"
        @mouseup="splitMouseUp()"
        @mousemove="splitMouseMove($event)"
        @mouseleave="splitLeave($event)"
        @mousewheel="splitWheel($event)"
        v-show="splitVisible"
      ></canvas>
    </div>
    <Dialog search :open="loading" :cancel="cancelLoad" title="読み込み中" body="お待ちください。"/>
    <Dialog error :open="error" title="エラー" :close="dialogClose" :body="errMessage"/>
  </section>
</template>

<script>
import Dialog from '../components/Dialog.vue'

export default {
  components: {
		Dialog,
  },
  data() {
    return {
      parent: null,
      canvas: null,
      context: null,
      canvasWidth_: 100,
      canvasHeight_: 100,
      tempCanvas: null,
      tempContext: null,
      image: null,
      imageWidth: 0,
      imageHeight: 0,
      loading: false,
      zooming: false,
      moving: false,
      mouseDown: false,
      scale: 1,
      startX: 0,
      startY: 0,
      imgX: 0,
      imgY: 0,
      overlayCanvas: null,
      overlayContext: null,
      frameMoving: false,
      frameLeft: 0,
      frameTop: 0,
      //frameX: 0,
      //frameY: 0,
      //frameWidth: 0,
      //frameHeight: 0,
      splitCanvas: null,
      splitContext: null,
      splitMoving: false,
      splitFrameLeft: 0,
      splitFrameTop: 0,
      splitRowNum: 1,
      splitColNum: 1,
      splitFlag: [[true]],
      splitSheets: [],
      canvasWidthRatio: 1,
      error: false,
      errMessage: '読み込めません',
      drawingMethod: 2, //test
    }
  },
  props: {
    canvasId: {
      type: String,
      default: 'canvas',
    },
    minScale: {
      type: Number,
      default: 1,
    },
    imageUrl: {
      type: String,
      required: true,
    },
    imageScale: {
      type: Number,
      default: 1,
    },
    frameVisible: {
      type: Boolean,
      default: false,
    },
    framePos: {
      type: Object,
      default: null,
    },
    splitVisible: {
      type: Boolean,
      default: false,
    },
    descText: {
      type: Array,
      default: null,
    },
    additionalTextSize: {
      type: Number,
      default: 20,
    },
    mouseClick: {
      type: Function,
      default: null,
    },
    enableWheel: {
      type: Boolean,
      default: true,
    },
    wheelZoom: {
      type: Number,
      default: 1.5,
    },
  },
  watch:{
    imageUrl: {
      immediate: true,
      handler(value) {
        this.startX = 0;
        this.startY = 0;
        this.offsetLeft = 0;
        this.offsetTop = 0;
        this.scale = 1;
        if (value) {
          this.initImage(value);
        }
      }
    },
    scale: {
      immediate: true,
      handler(value) {
        if (value == 1) {
          this.offsetLeft = 0;
          this.offsetTop = 0;
        }
      }
    },
    imageScale: {
      immediate: true,
      handler(value) {
        if (value && this.canvas && !this.zooming) {
          const ratio = this.image.width / (this.parent.clientWidth * value);
          if (ratio >= 1) {
            const cx = this.canvas.width / 2;
            const cy = this.canvas.height / 2;
            //const cx = parent.clientWidth / 2;
            //const cy = parent.clientHeight / 2;
            this.zoomImage(value / this.scale, cx, cy);
          }
          else {
            //原寸を超えて拡大はしない
            this.$emit('scaleChanged', this.scale);
          }
        }
      }
    },
    framePos: {
      immediate: true,
      handler(value) {
        if (value && this.image) {
          this.overlayLeft = value.x * this.image.width / this.canvas.width + this.offsetLeft;
          this.overlayTop = value.y * this.image.width / this.canvas.width + this.offsetTop;
        }
      }
    },
    /*
    parentWidth: {
      immediate: true,
      handler(value) {
        if (value && this.imageUrl) {
          this.initCanvas(this.imageUrl);
        }
      }
    },
    */
},
  mounted () {
    this.canvas = document.getElementById(this.canvasId);
    this.parent = this.canvas.parentElement;
    this.context = this.canvas.getContext('2d');
    this.context.imageSmoothingEnabled = true;
    this.context.imageSmoothingQuality = 'high';
    this.tempCanvas = document.createElement('canvas');
    this.tempContext = this.tempCanvas.getContext('2d');
    this.tempContext.imageSmoothingEnabled = true;
    this.tempContext.imageSmoothingQuality = 'high';
    this.overlayCanvas = document.getElementById('overlay-canvas');
    this.overlayContext = this.overlayCanvas.getContext('2d');
    this.splitCanvas = document.getElementById('split-canvas');
    this.splitContext = this.splitCanvas.getContext('2d');
    //this.frameWidth = this.pixA3Width;
    //this.frameHeight = this.pixA3Height;
  },
  /*
  updated () {
    if (this.canvas && this.canvas.width == 0 && this.parentWidth > 0) {
      this.initCanvas(this.imageUrl);
    }
  },
  */
  computed: {
    parentWidth() {
      return this.parent ? this.parent.clientWidth : 0;
    },
    canvasWidth: {
      get() { return this.canvasWidth_; },
      set(val) {
        if (this.image) {
          this.canvasWidth_ = val;
          const height = val * this.image.height / this.image.width;
          this.canvasHeight_ = height;
          this.canvas.style.width = `${val}px`;
          this.canvas.style.height = `${height}px`;
        }
      }
    },
    canvasHeight: {
      get() { return this.canvasHeight_; },
      set(val) {
        if (this.image) {
          this.canvasHeight_ = val;
          const width = val * this.image.width / this.image.height;
          this.canvasWidth_ = width;
          this.canvas.style.width = `${width}px`;
          this.canvas.style.height = `${val}px`;
        }
      }
    },
    offsetLeft: {
      get() { return this.imgX; },
      set(val) {
        if (this.canvas) {
          const diff = val - this.imgX;
          this.imgX = val;
          const flg = true;
          if (flg) {
            this.parent.scrollBy(-diff, 0);
          }
          else {
            this.canvas.style.left = this.imgX + 'px';
            this.overlayLeft += diff;
            this.splitLeft += diff;
          }
        }
      }
    },
    offsetTop: {
      get() { return this.imgY; },
      set(val) {
        if (this.canvas) {
          const diff = val - this.imgY;
          this.imgY = val;
          const flg = true;
          if (flg) {
            this.parent.scrollBy(0, -diff);
          }
          else {
            this.canvas.style.top = this.imgY + 'px';
            this.overlayTop += diff;
            this.splitTop += diff;
          }
        }
      }
    },
    overlayLeft: {
      get() { return this.frameLeft; },
      set(val) {
        if (this.overlayCanvas) {
          this.frameLeft = val;
          this.overlayCanvas.style.left = this.frameLeft + 'px';
        }
      }
    },
    overlayTop: {
      get() { return this.frameTop; },
      set(val) {
        if (this.overlayCanvas) {
          this.frameTop = val;
          this.overlayCanvas.style.top = this.frameTop + 'px';
        }
      }
    },
    splitLeft: {
      get() { return this.splitFrameLeft; },
      set(val) {
        if (this.splitCanvas) {
          this.splitFrameLeft = val;
          this.splitCanvas.style.left = this.splitFrameLeft + 'px';
        }
      }
    },
    splitTop: {
      get() { return this.splitFrameTop; },
      set(val) {
        if (this.splitCanvas) {
          this.splitFrameTop = val;
          this.splitCanvas.style.top = this.splitFrameTop + 'px';
        }
      }
    },
    additionalHeight: {
      get() {
        if (this.descText && this.descText.length) {
          return this.descText.length * this.additionalTextSize * this.scale;
        }
        else {
          return 0;
        }
      }
    },
    mmA3Width() {
      //return 420;
      //return 409.63;
      return 404;
    },
    mmA3Height() {
      //return 296;
      //return 286.65;
      return 270;
    },
    inchA3Width() {
      return this.mmA3Width / 10 / 2.54;
    },
    inchA3Height() {
      return this.mmA3Height / 10 / 2.54;
    },
    pixA3Width() {
      return this.inchA3Width * 300; //DPI
    },
    pixA3Height() {
      return this.inchA3Height * 300; //DPI
    },
  },
  methods: {
    updateSplitSheets() {
      this.splitSheets = [];
      const w = this.pixA3Width;
      const h = this.pixA3Height;
      const xorg = (this.splitLeft - this.offsetLeft) * this.image.width / this.canvas.width;
      const yorg = (this.splitTop - this.offsetTop) * this.image.height / this.canvas.height;
      for (let i = 0; i < this.splitRowNum; i++) {
        for (let j = 0; j < this.splitColNum; j++) {
          if (this.splitFlag[i][j]) {
            this.splitSheets.push({
              x: xorg + w * j,
              y: yorg + h * i,
            })
          }
        }
      }
      this.$emit('splitUpdated', this.splitSheets);
    },
    drawSplit() {
      if (this.image) {
        const context = this.splitContext;
        context.clearRect(0, 0, this.splitCanvas.width, this.splitCanvas.height);
        context.lineWidth = 5;
        context.strokeStyle = 'rgba(96, 128, 192, 0.5)';
        //context.fillStyle = 'rgba(96, 128, 192, 0.1)';
        const w = this.pixA3Width * this.canvas.width / this.image.width;
        const h = this.pixA3Height * this.canvas.width / this.image.width;
        for (let i = 0; i < this.splitRowNum; i++) {
          for (let j = 0; j < this.splitColNum; j++) {
            const x = w * j;
            const y = h * i;
            if (this.splitFlag[i][j]) {
              context.fillStyle = 'rgba(96, 128, 192, 0.1)';
              context.strokeStyle = 'rgba(96, 128, 192, 0.5)';
            }
            else {
              context.fillStyle = 'rgba(48, 48, 48, 0.5)';
              context.strokeStyle = 'rgba(0, 0, 0, 0.5)';
            }
            context.fillRect(x, y, w, h);
            context.strokeRect(x, y, w, h);
          }
        }
      }
    },
    drawFrame() {
      if (this.image) {
        const context = this.overlayContext;
        context.clearRect(0, 0, this.overlayCanvas.width, this.overlayCanvas.height);
        context.lineWidth = 6;
        context.strokeStyle = 'rgba(192, 128, 96, 0.5)';
        context.fillStyle = 'rgba(192, 128, 96, 0.1)';
        context.fillRect(0, 0, this.overlayCanvas.width, this.overlayCanvas.height);
        context.strokeRect(0, 0, this.overlayCanvas.width, this.overlayCanvas.height);
      }
    },
    drawAdditionalText() {
      if (this.descText && this.descText.length) {
        this.context.fillStyle = '#ffffff';
        this.context.fillRect(0, this.canvas.height - this.additionalHeight,
          this.canvas.width, this.additionalHeight);
        const leftMargin = 30;
        const topMargin = 10;
        const fontSize = 12;
        this.context.fillStyle = '#000000';
        //this.context.font = `500 ${fontSize * this.scale}px "ＭＳ 明朝"`;
        this.context.font = `500 ${fontSize * this.scale}px "ＭＳ ゴシック"`;
        for (let i = 0; i < this.descText.length; i++) {
          const x = leftMargin * this.scale;
          const y = this.canvas.height - this.additionalHeight
            + (topMargin + fontSize * 1.2 * i) * this.scale
          this.context.fillText(this.descText[i], x, y);
        }
      }
    },
    drawImage(image, scale) {
      try {
        this.context.globalCompositeOperation = 'source-over';
        this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);
        if (this.drawingMethod == 1) {
          const tempCanvas = document.createElement('canvas');
          const tempContext = tempCanvas.getContext('2d');
          let ratio = this.canvas.width / image.width * scale;
          const zoom = Math.min(0.5, ratio * 2);
          tempCanvas.width = image.width;
          tempCanvas.height = image.height;
          let tmpImg = image;
          while (ratio < zoom) {
            tempCanvas.width = tmpImg.width * zoom;
            tempCanvas.height = tmpImg.height * zoom;
            tempContext.drawImage(tmpImg, 0, 0, tempCanvas.width, tempCanvas.height);
            ratio /= zoom;
            tmpImg = tempCanvas;
          }
          this.context.drawImage(tmpImg,
            0, 0, tmpImg.width, tmpImg.height,
            0, 0, this.canvas.width, this.canvas.height - this.additionalHeight);
        }
        else if (this.drawingMethod == 2) {
          //test
          /*
          const whRatio = image.width / image.height;
          if (whRatio > this.parent.clientWidth / this.image.clientHeight) {
            this.canvasWidth = this.parent.clientWidth * scale;
          }
          else {
            this.canvasHeight = this.parent.clientHeight * scale;
          }
          */
          //
          let ratio = this.canvas.width / image.width * scale;
          let srcRatio = 1;
          let dstRatio = 1;
          let srcImage = image;
          if (ratio < 1/2) {
            this.tempCanvas.width = image.width / 2;
            this.tempCanvas.height = image.height / 2;
            this.tempContext.fillStyle = '#ffffff';
            this.tempContext.fillRect(0, 0, this.tempCanvas.width, this.tempCanvas.height);
            this.tempContext.drawImage(image, 0, 0, image.width, image.height,
              0, 0, this.tempCanvas.width, this.tempCanvas.height);
            ratio *= 2;
            srcImage = this.tempCanvas;
            if (ratio < 1/2) {
              dstRatio /= 2;
              this.tempContext.drawImage(this.tempCanvas,
                0, 0, this.tempCanvas.width, this.tempCanvas.height,
                0, 0, this.tempCanvas.width * dstRatio, this.tempCanvas.height * dstRatio);
              ratio /= 2;
              if (ratio < 1/2) {
                srcRatio /= 2;
                dstRatio /= 2;
                this.tempContext.drawImage(this.tempCanvas,
                  0, 0, this.tempCanvas.width * srcRatio, this.tempCanvas.height * srcRatio,
                  0, 0, this.tempCanvas.width * dstRatio, this.tempCanvas.height * dstRatio);
                
                //ratio /= 2;
                //if (ratio < 1/2) {
                //  srcRatio /= 2;
                //  dstRatio /= 2;
                //  tempContext.drawImage(tempCanvas, 0, 0, tempCanvas.width * srcRatio, tempCanvas.height * srcRatio,
                //    0, 0, tempCanvas.width * dstRatio, tempCanvas.height * dstRatio);
                //}
              }
            }
          }
          this.context.fillStyle = '#ffffff';
          this.context.fillRect(0, 0, this.canvas.width, this.canvas.height);
          this.context.drawImage(srcImage,
            0, 0, srcImage.width * dstRatio, srcImage.height * dstRatio,
            0, 0, this.canvas.width, this.canvas.height - this.additionalHeight);
        }
        else if (this.drawingMethod == 3) {
          this.canvasWidth = this.parent.clientWidth * scale;
          const ratio = image.width / (this.parent.clientWidth * scale);
          if (ratio > 8) {
            this.canvas.width = image.width / 8;
            this.canvas.height = image.height / 8;
            const tempCanvas = document.createElement('canvas');
            const tempContext = tempCanvas.getContext('2d');      
            tempCanvas.width = image.width / 2;
            tempCanvas.height = image.height / 2;
            tempContext.drawImage(image, 0, 0, image.width, image.height, 0, 0,
              tempCanvas.width, tempCanvas.height);       
            tempContext.drawImage(tempCanvas, 0, 0, tempCanvas.width, tempCanvas.height,
              0, 0, tempCanvas.width / 2, tempCanvas.height / 2);       
            this.context.drawImage(tempCanvas, 0, 0, tempCanvas.width / 2, tempCanvas.height / 2,
              0, 0, this.canvas.width, this.canvas.height);
          }
          else if (ratio > 4) {
            this.canvas.width = image.width / 4;
            this.canvas.height = image.height / 4;
            const tempCanvas = document.createElement('canvas');
            const tempContext = tempCanvas.getContext('2d');      
            tempCanvas.width = image.width / 2;
            tempCanvas.height = image.height / 2;
            tempContext.drawImage(image, 0, 0, image.width, image.height,
              0, 0, tempCanvas.width, tempCanvas.height);       
            this.context.drawImage(tempCanvas, 0, 0, tempCanvas.width, tempCanvas.height,
              0, 0, this.canvas.width, this.canvas.height);
          }
          else if (ratio > 2) {
            this.canvas.width = image.width / 2;
            this.canvas.height = image.height / 2;
            this.context.drawImage(image, 0, 0, image.width, image.height,
              0, 0, this.canvas.width, this.canvas.height);
          }
          else {
            this.canvas.width = image.width;
            this.canvas.height = image.height;
            this.context.drawImage(image, 0, 0, image.width, image.height,
              0, 0, this.canvas.width, this.canvas.height);
          }
        }
        this.drawAdditionalText();
      }
      catch (err) {
        console.log(`ImageCanvas.drawImage: error - ${err}`);
      }
    },
    loadImage(src) {
      return new Promise((resolve, reject) => {
        this.loading = true;
        const image = new Image();
        image.src = src;
        image.onload = function() {
          resolve(image);
        }
        image.onerror = function(error){
          reject(error);
        }
      });
    },
    initImage(srcUrl) {
      this.loading = true;
      try {
        this.loadImage(srcUrl)
        .then(img => {
          this.image = img;
          this.imageWidth = img.width;
          this.imageHeight = img.height;
          this.initCanvas(img);
          this.$emit('loaded', img);
          this.loading = false;
        })
        .catch(err => {
          console.log(`ImageCanvas.initImage(${srcUrl}) caught exception:`);
          console.log(err);
          this.loadError();
        });
      }
      catch (err) {
        this.loading = false;
        console.log(err);
      }
    },
    initCanvas(img) {
      //this.frameX = (img.width - this.pixA3Width) / 2;
      //this.frameY = (img.height - this.pixA3Height) / 2;
      this.canvas.width = this.parent.clientWidth * this.canvasWidthRatio;
      this.canvas.height = this.canvas.width * (img.height / img.width) + this.additionalHeight;
      this.drawImage(img, this.scale);
      this.overlayCanvas.width = this.pixA3Width * this.canvas.width / img.width;
      this.overlayCanvas.height = this.pixA3Height * this.canvas.height / img.height;
      this.overlayLeft = (this.framePos ? this.framePos.x : 0) / this.image.width * this.canvas.width + this.offsetLeft;
      this.overlayTop = (this.framePos ? this.framePos.y : 0) / this.image.height * this.canvas.height + this.offsetTop;
      this.drawFrame();
      this.splitRowNum = Math.ceil(img.height / this.pixA3Height);
      this.splitColNum = Math.ceil(img.width / this.pixA3Width);
      this.splitCanvas.width = this.pixA3Width * this.splitColNum * this.canvas.width / img.width;
      this.splitCanvas.height = this.pixA3Height * this.splitRowNum * this.canvas.height / img.height;
      this.splitFlag = [];
      for (let i = 0; i < this.splitRowNum; i++) {
        let row = [];
        for (let j = 0; j < this.splitColNum; j++) {
          row.push(true);
        }
        this.splitFlag.push(row);
      }
      this.updateSplitSheets();
      this.drawSplit();
    },
    cancelLoad() {
      this.loading = false;
    },
    loadError() {
      this.loading = false;
      this.error = true;
      this.errMessage = '画像ファイルが読み込めません。';
    },
    dialogClose() {
      this.loading = false;
      this.error = false;
    },
    onMouseDown(event) {
      this.startX = event.clientX;
      this.startY = event.clientY;
      this.mouseDown = true;
    },
    overlayMouseDown(event) {
      this.startX = event.clientX;
      this.startY = event.clientY;
      this.frameMoving = true;
    },
    splitMouseDown(event) {
      this.startX = event.clientX;
      this.startY = event.clientY;
      this.splitMoving = true;
    },
    onMouseUp() {
      this.mouseDown = false;
      this.frameMoving = false;
    },
    overlayMouseUp() {
      this.frameMoving = false;
    },
    splitMouseUp() {
      this.splitMoving = false;
    },
    onMouseMove(event){
      this.$emit('mouseMove', {
        x: event.offsetX,
        y: event.offsetY
      });
      if (this.mouseDown) {
        this.moving = true;
        this.offsetLeft += event.clientX - this.startX;
        this.offsetTop += event.clientY - this.startY;
        this.startX = event.clientX;
        this.startY = event.clientY;
        this.$emit('imgMoved', {
          x: this.offsetLeft, y: this.offsetTop
        });
        this.moving = false;
      }
    },
    overlayMouseMove(event) {
      if (this.frameMoving) {
        this.overlayLeft += event.clientX - this.startX;
        this.overlayTop += event.clientY - this.startY;
        this.startX = event.clientX;
        this.startY = event.clientY;
        this.$emit('frameMoved', {
          x: (this.overlayLeft - this.offsetLeft) * this.image.width / this.canvas.width,
          y: (this.overlayTop - this.offsetTop) * this.image.height / this.canvas.height
        })
      }
    },
    splitMouseMove(event) {
      if (this.splitMoving) {
        this.splitLeft += event.clientX - this.startX;
        this.splitTop += event.clientY - this.startY;
        this.startX = event.clientX;
        this.startY = event.clientY;
        this.updateSplitSheets();
      }
    },
    /**
     * @param {Number} zoom 拡大率（現在の値を1とする）
     * @param {Number} cx 拡大中心の画面X座標
     * @param {Number} cy 拡大中心の画面Y座標
     */
    zoomImage(zoom, cx, cy) {
      this.zooming = true;
      const prevScale = this.scale;
      const minScale = this.minScale; //0.5; //1.0
      this.scale = Math.max(minScale, this.scale * zoom);
      const scaleRatio = this.scale / prevScale;
      const dx = -cx * (scaleRatio - 1);
      const dy = -cy * (scaleRatio - 1);
      this.canvas.width = this.parent.clientWidth * this.canvasWidthRatio * this.scale;
      this.canvas.height = this.canvas.width * (this.image.height / this.image.width) + this.additionalHeight;
      if (this.overlayCanvas) {
        this.overlayLeft = this.overlayLeft * scaleRatio;
        this.overlayTop = this.overlayTop * scaleRatio;
        this.overlayCanvas.width = this.pixA3Width * this.canvas.width / this.image.width;
        this.overlayCanvas.height = this.pixA3Height * this.canvas.height / this.image.height;
      }
      if (this.splitCanvas) {
        this.splitLeft = this.splitLeft * scaleRatio;
        this.splitTop = this.splitTop * scaleRatio;
        this.splitCanvas.width = this.splitColNum * this.pixA3Width * this.canvas.width / this.image.width;
        this.splitCanvas.height = this.splitRowNum * this.pixA3Height * this.canvas.height / this.image.height;
      }
      this.offsetLeft += dx;
      this.offsetTop += dy;
      this.drawImage(this.image, this.scale);
      this.drawFrame();
      this.drawSplit();
      this.zooming = false;
    },
    onMouseWheel(event) {
      if (this.enableWheel) {
        event.preventDefault();
        if (!this.zooming) {
          //const wheel = Math.abs(event.deltaY / 100);
          //const zoom = wheel * (event.deltaY < 0 ? 1.5 : 1/1.5);
          const zoom = (event.deltaY < 0 ? this.wheelZoom : 1/this.wheelZoom);
          //const scale = Math.max(1, this.scale * zoom);
          //const minScale = (this.image.width > this.image.height) ? 1 : this.image.width / this.image.height;
          const minScale = this.minScale; //0.5;
          const scale = Math.max(minScale, this.scale * zoom);
          const ratio =  this.image.width / (this.parent.clientWidth * scale);
          //console.log(`deltaY:${event.deltaY} wheel:${wheel} zoom:${zoom}`);
          //console.log(`minScale:${minScale} scale:${scale} ratio:${ratio}`);
          /*
          const ratio = (this.image.width > this.image.height) ? 
            this.image.width / (this.canvas.width * scale) :
            this.image.height / (this.canvas.height * scale);
          */
          if (scale <= 1 || ratio >= 1) {
            //原寸を超えて拡大はしない
            this.zoomImage(zoom, event.offsetX, event.offsetY);
            this.$emit('scaleChanged', this.scale);
          }
        }
      }
    },
    overlayWheel(event) {
      if (this.enableWheel) {
        const wheel = Math.abs(event.deltaY / 100);
        const zoom = wheel * (event.deltaY < 0 ? this.wheelZoom : 1/this.wheelZoom);
        const x = this.overlayLeft - this.offsetLeft + event.offsetX;
        const y = this.overlayTop - this.offsetTop + event.offsetY;
        this.zoomImage(zoom, x, y);
        this.$emit('scaleChanged', this.scale);
      }
    },
    splitWheel(event) {
      if (this.enableWheel) {
        const wheel = Math.abs(event.deltaY / 100);
        const zoom = wheel * (event.deltaY < 0 ? this.wheelZoom : 1/this.wheelZoom);
        const x = this.splitLeft - this.offsetLeft + event.offsetX;
        const y = this.splitTop - this.offsetTop + event.offsetY;
        this.zoomImage(zoom, x, y);
        this.$emit('scaleChanged', this.scale);
      }
    },
    onMouseLeave() {
      if (this.mouseDown) {
        this.mouseDown = false;
      }
    },
    overlayLeave() {
      this.frameMoving = false;
    },
    splitLeave() {
      this.splitMoving = false;
    },
    onClick(event) {
      if (this.mouseClick) {
        const x = event.offsetX * this.image.width / this.canvas.width;
        const y = event.offsetY * this.image.width / this.canvas.width;
        this.mouseClick(x, y);
      }
    },
    overlayClick(event) {
      if (this.mouseClick) {
        const x = (this.overlayLeft + event.offsetX) * this.image.width / this.canvas.width;
        const y = (this.overlayTop + event.offsetY) * this.image.width / this.canvas.width;
        this.mouseClick(x, y);
      }
    },
    splitClick(event) {
      if (this.mouseClick) {
        const x = (this.splitLeft + event.offsetX) * this.image.width / this.canvas.width;
        const y = (this.splitTop + event.offsetY) * this.image.width / this.canvas.width;
        this.mouseClick(x, y);
      }
    },
    splitDblClick(event) {
      const w = this.pixA3Width * this.canvas.width / this.image.width;
      const h = this.pixA3Height * this.canvas.height / this.image.height;
      const col = Math.floor(event.offsetX / w);
      const row = Math.floor(event.offsetY / h);
      this.splitFlag[row][col] = !this.splitFlag[row][col];
      this.updateSplitSheets();
      this.drawSplit();
    }
  }
}
</script>
<style lang="scss" scoped>
.image-viewer {
  width: 100%;
  height: 100%;
  margin: 0 auto;
  overflow: auto;
}
.grab-bing {
	cursor : -webkit-grab;
	cursor : -moz-grab;
	cursor : -o-grab;
	cursor : grab;
}
.grab-bing:active {
	cursor : -webkit-grabbing;
	cursor : -moz-grabbing;
	cursor : -o-grabbing;
	cursor : grabbing;
}
.scroll-hidden {
	overflow: hidden;
}
.description {
  position: absolute;
  top: calc(100% - 115px);
  background-color: white;
  font-family: 'MS Gothic';
  font-size: 9pt;
  padding-left: 10mm;
  overflow-x: hidden;
  user-select: none;
}
.canvas-parent {
  width:100%;
  height:100%;
  overflow:auto;
  position:relative;
}
@media print {
  * {
    background-color: white;
  }
  .image-viewer {
    overflow: hidden;
  }
  .canvas-parent {
    overflow:hidden;
  }
}
/*
main > p{ width:800px; }
//以下はタブレット以下のサイズ用
@media screen and (min-width:0px) and (max-width: 1023px){
   main > p{ width:100%; height:600px; }
   main > p img{ height:100%; }
}
*/
</style>